export const EnqueteTemplates = {
  path: '/enquete_templates',
  meta: { requiresAuth: true },
  component: () => import('layouts/MainLayout.vue'),
  children: [
    {
      path: '',
      name: 'enqueteTemplates',
      component: () => import('pages/enqueteTemplates/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.enqueteTemplates.name',
        path: '/enquete_templates',
        condition: 'enqueteTemplate',
      },
    },
    {
      path: 'create',
      name: 'enqueteTemplates-create',
      component: () => import('pages/enqueteTemplates/CreatePage.vue'),
      meta: {
        requiresAuth: true,
        title: 'pageType.create',
        parents: [
          {
            title: 'page.enqueteTemplates.name',
            path: '/enquete_templates',
            condition: 'enqueteTemplate',
          },
        ],
      },
    },
    {
      path: ':id',
      name: 'enqueteTemplates-id',
      component: () => import('pages/enqueteTemplates/id/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: ':name',
        parents: [
          {
            title: 'page.enqueteTemplates.name',
            path: '/enquete_templates',
            condition: 'enqueteTemplate',
          },
        ],
      },
    },
    {
      path: ':id/edit',
      name: 'enqueteTemplates-id-edit',
      component: () => import('src/pages/enqueteTemplates/id/EditPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'pageType.edit',
        parents: [
          {
            title: 'page.enqueteTemplates.name',
            path: '/enquete_templates',
            condition: 'enqueteTemplate',
          },
          {
            title: ':name',
            path: '/enquete_templates/:id',
          },
        ],
      },
    },
  ],
};
